
import { Vue, Component, Prop } from 'vue-property-decorator';
import { SgkKamuCevap } from '@/plugins/uyap-plugin/uyap/SgkKamu';

@Component({})
export default class KamuAktifDetay extends Vue {
  @Prop() data!: SgkKamuCevap;

  get kamuBilgi() {
    return this.data.sorguSonucDVO;
  }

  get hasData() {
    return this.kamuBilgi && (this.kamuBilgi.tckn || this.kamuBilgi.hataKodu === 995);
  }

  getDurumColor(durumKapsami: string) {
    if (!durumKapsami) return 'grey';
    const durum = durumKapsami.toLowerCase().trim();
    if (durum.includes('aktif')) return 'success';
    if (durum.includes('pasif')) return 'error';
    return 'warning';
  }
}
